<div class="market-history">
  <ul class="nav nav-pills" role="tablist">
    <li class="nav-item">
      <a class="nav-link active text-center" data-toggle="pill" (click)="setNewsView(true)" role="tab" aria-selected="true">
        <h6>{{"news"|translate}}</h6>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="pill" (click)="setNewsView(false)" role="tab" aria-selected="false">
        <h6>{{"announcements"|translate}}</h6>
      </a>
    </li>
  </ul>

  <div class="custom-news-container" *ngIf="isMarket" >
    <div class="row no-data m-0" *ngIf="!companyNews && !isMarketNewsLoading">
      <div class="col-md-12">
        <img class="empty-state" src="/assets/img/noData.png" />
        <div class="col-sm-12">
          <h6 class="nodata-msg"> {{"select-company-hint"|translate}} </h6>
        </div>
      </div>
    </div>
    <div class="row no-data m-0" *ngIf="companyNews && companyNews.length == 0 && !isMarketNewsLoading">
      <div class="col-md-12">
        <img class="empty-state" src="/assets/img/noData.png" />
        <div class="col-sm-12">
          <h6 class="nodata-msg"> {{'no-news-hint'|translate}} </h6>
        </div>
      </div>
    </div>
    <tbody class="d-flex justify-content-center" *ngIf="isMarketNewsLoading">
      <div class="spinner-border  text-secondary m-5" role="status">
        <span class="sr-only"></span>
      </div>
    </tbody>
    <div *ngIf="!isMarketNewsLoading && isNewsView && companyNews.length>0" style="height: 100% !important;">
      <ul>
        <li class="news-card-bg" *ngFor="let item of companyNews"><a (click)="openNewsModal(item)" style="text-align: start;">
            <div style="font-size: 14px; font-weight: 500;">
              {{(translate.currentLang=='ar' && item.ARB_HEADING)?item.ARB_HEADING:item.HEADING}}
            </div>
            {{item.SHORT_DESC}}
            <div class="d-flex justify-content-between mt-2">
              <span>
                {{item.DATE_STAMP}}
              </span>
              <span class="news-type-badge rounded-pill" [ngStyle]="getColor(item.SEC_ID)">
                {{(translate.currentLang=='en')?item.SECTION:item.SECTION_ARB}}
              </span>
            </div>
          </a></li>
      </ul>
    </div>
    <div *ngIf="!isMarketNewsLoading && isNewsView && companyNews.length==0" style="height: 100% !important;">
      <div class="row no-data m-0" >
        <div class="col-md-12">
          <img class="empty-state" src="/assets/img/noData.png" />
          <div class="col-sm-12">
            <h6 class="nodata-msg"> {{'no-news-hint'|translate}} </h6>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isMarketNewsLoading && !isNewsView && announcements.length>0" style="height: 100% !important;">
      <ul >
        <li class="news-card-bg" *ngFor="let item of announcements"><a (click)="openNewsModal(item)" style="text-align: start;">
            <div style="font-size: 14px; font-weight: 500;">{{(translate.currentLang=='en')?item.HEADING:item.ARB_HEADING}}</div>
            {{item.SHORT_DESC}}
            <span>{{item.DATE_STAMP}}</span>
          </a></li>
      </ul>
    </div>
  </div>

  <app-not-full-market *ngIf="!isMarket"></app-not-full-market>

</div>
